import { formatRichText, replacePricesInString } from "./richText";
import { getBGfromVariant } from "./contentBlockStyling";

export const contentfulImageUrl = fieldData => fieldData?.fields?.file?.url;
export const contentfulImageAlt = fieldData => fieldData?.fields?.title;
export const contentfulToImageData = fieldData => ({
	imageUrl: contentfulImageUrl(fieldData),
	alt: contentfulImageAlt(fieldData),
	fileType: contentfulImageUrl(fieldData)?.split(".").pop(),
	description: fieldData?.fields?.description || "",
});

export const formatDescriptions = descriptionField =>
	descriptionField?.content?.map(({ content }) => content[0]?.value);

export const contentfulToAccordion = (accordionData, siteStatus, parsedFunctions) => {
	if (!accordionData) return [];
	const formattedAccordionData = accordionData.map(({ fields }) => {
		const { title, content } = fields || {};
		if(!content || !title) return null;
		return {
			title,
			content: formatRichText(content, siteStatus, [], parsedFunctions),
		};
	}).filter(item => item !== null);
	return formattedAccordionData;
};

export const contentfulToTile = tileData => {
	if (!tileData) return [];
	return tileData.map(({ fields }) => {
		const { title, iconImage } = fields || {};
		if(!title) return null;
		return {
			title,
			iconImage: contentfulImageUrl(iconImage),
			tileHeight: 160,
		};
	}).filter(item => item !== null);
};

const safelyFormatUrl = url => {
	if (!url) return null;
	if (url.startsWith("http") || url.startsWith("https")) return url;
	if (url.startsWith("/")) return url;
	return `/${url}`;
};

export const contentfulToCTA = (ctaData, siteStatus, isStatic) => {
	if (!ctaData?.fields) return null;

	const { title, url, priceTag, variant, buttonText } = ctaData.fields;
	const ctaPrice = priceTag?.fields?.value
		? replacePricesInString(priceTag.fields.value, siteStatus)
		: null;

	return {
		title: buttonText ?? title,
		url: safelyFormatUrl(url),
		priceTag: ctaPrice,
		variant,
		image: ctaData?.fields?.image ? contentfulToImageData(ctaData.fields?.image) : null,
		icon: ctaData?.fields?.icon ? contentfulToImageData(ctaData.fields?.icon) : null,
		buttonStyling: ctaData?.fields?.buttonStyling ?? [],
		separator: ctaData?.fields?.separator ?? null,
		mobileOnly: ctaData?.fields?.mobileOnly ?? false,
		desktopOnly: ctaData?.fields?.desktopOnly ?? false,
		onClickFunction: ctaData?.fields?.onClickFunction ?? null,
		isStatic: isStatic ?? false,
	};
};

export const contentfulToVideoData = contentfulVideoData => {
	if (!contentfulVideoData) return null;
	const { title, file } = contentfulVideoData.fields;
	return {
		title,
		url: file?.url,
	};
};

export const getTokenValue = token => {
	if (!token) return null;
	const tokenValue = token?.fields?.value;
	if (tokenValue) {
		return tokenValue;
	}
	return null;
};

export const formatCTAS = (ctaArray, siteStatus, isStatic) => {
	if (!ctaArray || !Array.isArray(ctaArray)) return [];
	return ctaArray.flatMap(cta => {
		const formattedCTA = contentfulToCTA(cta, siteStatus, isStatic);
		if (formattedCTA) {
			return formattedCTA;
		}
		return [];
	});
};

export const formatTiles = tiles => {
	return tiles?.flatMap(({ fields }) => {
		const { title, iconImage, tileText, backgroundColor } = fields || {};
		if (!title) return [];
		const imageData = contentfulToImageData(iconImage);
		return {
			title: tileText || title,
			imageUrl: imageData.imageUrl || null,
			alt: imageData.alt || title,
			isIcon: imageData.fileType === "svg",
			backgroundColor: getBGfromVariant(backgroundColor),
			url: fields?.url || null,
		};
	});
};


export const  getContentTypeId = sysInfo => {
	if (!sysInfo) return null;
	const { contentType } = sysInfo;
	if (!contentType) return null;
	const { sys } = contentType;
	if (!sys) return null;
	return sys.id;
};